var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h1',{staticClass:"main-title"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.$t('meta.title')))]),_c('logo-composite',{attrs:{"centered":_vm.isLogoCentered,"label":_vm.$t('logos.radio17')}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }